import React from "react"
import { TextVideoPairBlade } from "@organic-return/foundation-react/src/components/Blades/TextVideoPairBlade"


const TextVideoPair = ({ module }) => {

    const fields = module.customFields
    return (
        <TextVideoPairBlade
            title={fields.title}
            headingCTA={fields.headingCTA}
            colsWrapperClassName="mt-14 lg:px-20"
            textColTitle={fields.textColumnTitle}
            textColText={fields.textColumnText}
            textColCTA={fields.textColumnCTA}
            video={fields.video}
            videoPosition={fields.videoPosition}
            videoPoster={fields.videoPoster?.url}
        />
    )
}

export default TextVideoPair